// rules.jsx
import React, { useEffect, useState } from 'react';
import './rules.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { selectAdminToken } from '../../admin/sessionSlice';
import { setBackButtonUrl } from '../uiSlice';
import { shouldUseMobileBackground } from "../game/bugGame/themeAssets";

function UserRules() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );
  const { status, user, error } = useSelector((state) => state.auth);
  const [redirect, setRedirect] = useState("/fullhouse");
  const adminToken = useSelector(selectAdminToken);
  const useMobileBg = shouldUseMobileBackground();
  const rulesBgAsset =
    (useMobileBg ? themeData?.background_mob : themeData?.background_desk) ||
    themeData?.bg_image ||
    "";
  const rulesBgUrl = rulesBgAsset
    ? encodeURI(`${process.env.REACT_APP_S3_PATH}${rulesBgAsset}`)
    : "";

  useEffect(() => {
    if (!themeData) return;

    setRedirect("/game");
  }, [themeData]);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [status, user]);

  useEffect(() => {
    const prevBodyOverflow = document.body.style.overflow;
    const prevHtmlOverflow = document.documentElement.style.overflow;
    const prevBodyOverscroll = document.body.style.overscrollBehavior;
    const prevHtmlOverscroll = document.documentElement.style.overscrollBehavior;

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.body.style.overscrollBehavior = "none";
    document.documentElement.style.overscrollBehavior = "none";

    return () => {
      document.body.style.overflow = prevBodyOverflow;
      document.documentElement.style.overflow = prevHtmlOverflow;
      document.body.style.overscrollBehavior = prevBodyOverscroll;
      document.documentElement.style.overscrollBehavior = prevHtmlOverscroll;
    };
  }, []);

  useEffect(() => {
    const prevBodyBgImage = document.body.style.backgroundImage;
    const prevBodyBgPosition = document.body.style.backgroundPosition;
    const prevBodyBgRepeat = document.body.style.backgroundRepeat;
    const prevBodyBgSize = document.body.style.backgroundSize;

    if (rulesBgUrl) {
      document.body.style.backgroundImage = `url(${rulesBgUrl})`;
      document.body.style.backgroundPosition = "center";
      document.body.style.backgroundRepeat = "no-repeat";
      document.body.style.backgroundSize = "100% 100%";
    }

    return () => {
      document.body.style.backgroundImage = prevBodyBgImage;
      document.body.style.backgroundPosition = prevBodyBgPosition;
      document.body.style.backgroundRepeat = prevBodyBgRepeat;
      document.body.style.backgroundSize = prevBodyBgSize;
    };
  }, [rulesBgUrl]);

  const handleNextClick = (e) => {
    e.preventDefault();
    navigate(redirect);
  };


  if (!themeData) {
    return (
      <div className='quiz-loader-container'>
        <div className="quiz-loader"></div>
      </div>
    );
  }

  return (
    <div
      className="user-rules-page"
    >
      <div className="user-rules-container">
        <div
          className="user-rules-heading"
          style={{
            background: themeData?.button_background ? themeData.button_background : "linear-gradient(180deg, " + themeData.button_color + ", " + themeData.button_color + ")",
            color: themeData?.button_text_color ? themeData.button_text_color : "#fff",
          }}
        >
          Before you smash
        </div>

        <div className="user-rules-card">
          <div className="user-rules-title-wrap">
            {themeData?.main_title && (
              <div className="user-rules-big-title">{themeData.main_title}</div>
            )}
            {themeData?.landing_page_title && (
              <div className="user-rules-subline">{themeData.landing_page_title}</div>
            )}
          </div>

          <ul className="user-rules-list">
            {
              themeData?.rules.map((rules, index) => (
                <li key={index} style={{color: themeData.text_color}}>
                  <i
                    className="fa fa-arrow-right user-rule-icon"
                    aria-hidden="true"
                  />
                  {rules}
                </li>
              ))
            }
          </ul>

          <div className="user-next-wrap">
            <button
             style={{
              background: themeData?.button_background ? themeData.button_background : "linear-gradient(180deg, " + themeData.button_color + ", " + themeData.button_color + ")",
              color: themeData?.button_text_color ? themeData.button_text_color : "#fff",
            }}
              className="user-next-button"
              onClick={handleNextClick}
              aria-label="Next"
            >
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserRules;